import * as layout from '../../components/markLayout.module.css';
import React from 'react';
import P from '@hero/ui-kit/typography/P';
import Tag from '@hero/ui-kit/components/Tag';
import Tooltip from '@hero/ui-kit/components/Tooltip';
import { formatDateTime, normalizeDateString } from '@hero/hero-utils/date';
import type { ContactDetail } from '../../types';
type Props = {
    contact: ContactDetail;
};
const ContactSummary: React.FC<Props> = ({ contact }) => {
    return (
        <div className={layout.summaryGrid}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '0.8rem'
                }}
            >
                <P noDefaultMargin>
                    <strong>Email:</strong> {contact.email}
                </P>
                <P noDefaultMargin>
                    <strong>Phone:</strong> {contact.phone || '—'}
                </P>
                <P noDefaultMargin>
                    <strong>Hero User ID:</strong> {contact.hero_user_id ?? '—'}
                </P>
                <P noDefaultMargin>
                    <strong>Timezone:</strong>{' '}
                    {contact.timezone || (
                        <span
                            style={{
                                fontStyle: 'italic'
                            }}
                        >
                            Not set (falls back to America/Los_Angeles at send time)
                        </span>
                    )}
                </P>
                <P noDefaultMargin>
                    <strong>Created:</strong> {formatDateTime(normalizeDateString(contact.created))}
                </P>
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '0.8rem'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '0.8rem'
                    }}
                >
                    {contact.is_demo && (
                        <Tag type="warn" size="small">
                            DEMO
                        </Tag>
                    )}
                    {contact.is_placeholder && (
                        <Tag type="warn" size="small">
                            PLACEHOLDER
                        </Tag>
                    )}
                    {contact.suppressed && (
                        <Tooltip content={contact.suppression_reason || 'No reason provided'}>
                            <Tag type="fail" size="small">
                                SUPPRESSED
                            </Tag>
                        </Tooltip>
                    )}
                    <Tag type={contact.sms_subscribed ? 'success' : 'fail'} size="small">
                        {contact.sms_subscribed ? 'SMS Subscribed' : 'SMS Unsubscribed'}
                    </Tag>
                </div>
                {contact.hard_bounce_count > 0 && (
                    <P noDefaultMargin>
                        <strong>Hard bounces:</strong> {contact.hard_bounce_count}
                    </P>
                )}
                {contact.soft_bounce_count > 0 && (
                    <P noDefaultMargin>
                        <strong>Soft bounces:</strong> {contact.soft_bounce_count}
                    </P>
                )}
            </div>
            {/* Batch 5 will add MX write actions here */}
        </div>
    );
};
export default ContactSummary;
